import { z } from 'zod'

import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { FinanceEntityIdSchema } from './finance/finance-entity-id.ts'
import { BillingProfileIdSchema } from './unique-id.models.ts'

export const [ExternalChargeStatus, ExternalChargeStatusSchema] = EnumBuilder(
  'succeeded',
  'failed',
  'pending'
)

/**
 * ExternalCharge
 */

export const ExternalChargeSchema = z.object({
  billingProfileId: BillingProfileIdSchema,
  externalChargeId: z.number(),
  amount: z.number(),
  status: ExternalChargeStatusSchema,
})

export type ExternalCharge = ZodInfer<typeof ExternalChargeSchema>

/**
 * Webhook model for external charge report
 */

export const ExternalChargeReportWebhookSchema = z.object({
  brandId: FinanceEntityIdSchema,
  paymentId: z.number(),
  amount: z.number(),
  status: ExternalChargeStatusSchema,
})
